<template>
  <v-layout row justify-center>
    <v-dialog v-model="visible" content-class="us--dialog" width="325px" v-click-outside="close">
      <v-card content-class="us--dialog">
        <v-card-title class="title font-weight-regular justify-space-between">
          <span>{{ title }}</span>
        </v-card-title>
        <search :searchFilter.sync="searchFilter" />
        <v-list class="us--scroll-list">
          <v-list-tile
            v-for="item in filteredItems"
            :key="item.title"
            @click="onContactClicked(item)"
            :class="selected(item)"
            style="height: 45px !important;"
          >
            <v-list-tile-avatar>
              <user-avatar 
                :avatar="item.avatar"
                :username="item.name" 
                :size="38"
              />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-text="item.name" ></v-list-tile-title>
            </v-list-tile-content>

          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            flat
            @click="close"
          >
             {{ this.$t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="nextDisabled"
            color="primary"
            depressed
            @click="next"
          >
            {{ this.$t('next_btn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style>
  .us--dialog {
    height: 600px;
    table-layout: fixed;
  }
  .us--scroll-list {
    height: 458px;
    overflow: scroll;
  }
</style>

<script> 
  import UserAvatar from '@common/UserAvatar.vue'
  import Search from '@common/Search.vue'

  export default {
    name: 'user-select',
    data: () => ({
      items: [],
      selectedItems: [],
      searchFilter:'',
      filteredItems: []
    }),
    components: { UserAvatar, Search },
    computed: {
      nextDisabled() { return !this.selectedItems.length }
    },
    props: {
      visible: {
        type: Boolean, 
        default: false
      },
      title: {
        type: String
      },
      callback: Function,
      exclude: {
        type: Array,
        default: () => [],
      }
    },
    methods: {
      fetchContacts() {
        this.items = this.$store.state.contacts.filter(item => this.exclude.filter(e => e.contactId == item.contactId) == 0)       
        this.filteredItems = this.items
      },
      close() {
        if (!this.visible)
          return
        // reset all variables
        this.selectedItems = []
        this.searchFilter = ""
        this.$emit('update:visible', false)
      },
      next() {
        if (this.callback !== undefined) {
          this.callback(this.selectedContacts())
          this.close()
          return
        }
        this.close()
      },
      selected(item) {
        return (this.selectedItems.includes(item)) ? 'accent' : ''
      },
      selectedContacts() {
        let users = []
        this.selectedItems.forEach((item) => users.push(item.contactId))
        return users
      },
      onContactClicked(item){
        if (this.selectedItems.includes(item)) {
          this.selectedItems.splice(this.selectedItems.indexOf(item), 1 )
        } else {
          this.selectedItems.push(item)
        }
        //this.selectedItems = [item]
      }
    },
    watch: {
      visible: function(newValue, oldValue) {
        if (newValue)
          this.fetchContacts()
      },
      searchFilter: function(newValue, oldValue) {
        if (newValue && this.searchFilter!== '') {
          const filter = new RegExp(this.searchFilter, 'i')
          this.filteredItems = this.items.filter(it => it.name.match(filter))
        }
        else {
          this.filteredItems = this.items
        }
      }
    }
  }
</script>